(function () {
  if (window.__ssStockStatus) return;
  window.__ssStockStatus = true;

  const STATES = ['in', 'low', 'preorder', 'out'];

  function readMap(root) {
    const script = root.querySelector('[data-ss-stock-map]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.error('SS — carte de stock illisible :', e);
      return null;
    }
  }

  function update(root, variantId) {
    const map = readMap(root);
    if (!map) return;

    const entry = map[String(variantId)];
    const state = entry ? entry.state : 'out';
    const qty = entry ? entry.qty : 0;

    const key = 'label' + state.charAt(0).toUpperCase() + state.slice(1);
    const template = root.dataset[key] || '';
    const label = template.replace('{count}', qty);

    STATES.forEach((s) => root.classList.toggle('ss-ss--' + s, s === state));

    const el = root.querySelector('[data-ss-stock-label]');
    if (el) el.textContent = label;
  }

  function updateAll(variantId) {
    if (!variantId) return;
    document.querySelectorAll('[data-ss-stock]').forEach((root) => update(root, variantId));
  }

  /* --- Extraction de l'id depuis un event, quelle qu'en soit la forme --- */
  function extractId(detail) {
    if (!detail) return null;
    if (typeof detail === 'number' || typeof detail === 'string') return detail;
    return detail.variantId
      || detail.id
      || detail.variant?.id
      || detail.resource?.id
      || detail.data?.variant?.id
      || null;
  }

  /* --- Écoute des events de changement de variante --- */
  const EVENTS = [
    'variant:update',
    'variant:change',
    'variantChange',
    'product:variant-change',
    'on:variant:update',
    'on:variant:change'
  ];

  EVENTS.forEach((name) => {
    document.addEventListener(name, (e) => {
      const id = extractId(e.detail);
      if (id) updateAll(id);
    });
  });

  /* --- Repli : le champ caché du formulaire produit --- */
  document.addEventListener('change', (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    // Laisse le thème mettre à jour son input caché avant de lire
    requestAnimationFrame(() => {
      const input = form.querySelector('input[name="id"], select[name="id"]');
      if (input?.value) updateAll(input.value);
    });
  });

  /* --- Repli : paramètre variant dans l'URL --- */
  let lastVariant = new URLSearchParams(location.search).get('variant');

  function checkUrl() {
    const current = new URLSearchParams(location.search).get('variant');
    if (current && current !== lastVariant) {
      lastVariant = current;
      updateAll(current);
    }
  }

  window.addEventListener('popstate', checkUrl);

  ['pushState', 'replaceState'].forEach((method) => {
    const original = history[method];
    history[method] = function () {
      const result = original.apply(this, arguments);
      checkUrl();
      return result;
    };
  });

  document.addEventListener('shopify:block:select', (e) => {
    const root = e.target.querySelector?.('[data-ss-stock]') || e.target.closest?.('[data-ss-stock]');
    if (root && lastVariant) update(root, lastVariant);
  });
})();